export const BRAND = {
  name: "Way2Umrah",
  primary: "#c6272a",
  primaryDark: "#a81f22",
  primarySoft: "#fdecec",
  logo: "/branding/logo.jpeg",
  logoDark: "/branding/logo-dark.png",
  logoIcon: "/branding/favicon.png",
  favicon: "/branding/favicons.ico",
  termsUrl: "https://way2umrah.com/terms-and-conditions",
  privacyUrl: "https://way2umrah.com/privacy-policy",
};
